import Immutable from "immutable";
import {color} from "novo-design-tokens";

// backgrounds
export const charade = "#272731";
export const trout = "#484856";
export const boulder = "#757575";
export const wildSand = "#f2f2f2";
export const tuna = "#32323f";

export const bullhornNavy = color.midnight;
export const bullhornLightGrey = "#f2f2f2";
export const bullhornLightBlue = "#4a89dc";
export const bullhornOrange = color.bullhorn;
export const bullhornLightOrange = "#f6b042";

export const c19Yellow = "#f9ec33";
export const c19Green = "#61C152";
export const c19Red = "#F12F2F";

// Text
export const errorColor = "#f44336";

// App area accents
export const tvColor = "#ea4040";
export const sliceDiceColor = "#956bf5";
export const chartingColor = "#52dcf5";
export const jobsPipelineColor = "#48efa5";
export const onPointColor = "#ff7926";

// Group inheritance accents
export const musicColor = "#188c87";
export const pageColor = "#8350e6";
export const currencyColor = "#c74a4a";
export const localeColor = "#ff6a3e";
export const attributeNotSetColor = "rgba(0,0,0,0.1)";
export const attributeNotSetColorLight = "rgba(242,242,242,1)";

// Cube 2021 Theme
export const darkestGrey = "#1B1B1E";
export const greyDark = charade;
export const grey = tuna;
export const greyLight = "#484856";
export const greyText = "#8DABC4";
export const java = "#26c1c9";
export const greenLight = "#9AC379";
export const redLight = "#FF7A7A";
export const lightestRed = "#F4B8C6";
export const accentPurple = "#AB7DF6";
export const lightPurple = "#D9C2FF";
export const tableBorder = "#334B69";
export const blueBorder = "#67859E";

// Other (mainly used in squids or custom components)
// Leaderboard Colors
export const gold = "#D7B137";
export const silver = boulder;
export const bronze = "#CD8032";

//Squids
export const labelBg = tuna;
export const stepBg = "#314764";
export const lightText = "#5A6574";
export const accentBlue = "#5452f7";
export const offWhite = "#ecf5fd";
export const lightBackground = "#F6F6F6";
export const turquoiseLight = "#2fe1eb";
export const midGrey = "#989898";
export const futuristicPink = "#E80A89";

// Legacy
export const yellowText = c19Yellow;

// Light Theme
export const white = "#FFFFFF";
export const black = "#000000";
export const lightGrey = "#e4ecf7";
export const lightestGrey = "#F1F5FC";

//icon picker colours
export const blueIcon = "#26C1C7";
export const yellowIcon = "#F9EC33";
export const pinkIcon = "#F67DDB";
export const purpleIcon = "#AB7DF6";
export const greenIcon = "#93D45F";
export const redIcon = "#E1453B";
export const orangeIcon = "#fc9403";
export const darkGreenIcon = "#2c9132";

export const iconColors = Immutable.fromJS([
  redIcon,
  redLight,
  orangeIcon,
  yellowIcon,
  greenIcon,
  darkGreenIcon,
  accentBlue,
  blueIcon,
  purpleIcon,
  pinkIcon,
  white,
  greyLight]);

//branding
export const malachite = "#61C152"; //success cube green
export const pomegranate = "#F12F2F"; //error cube red

//app headings
export const cinnabar = "#ea4040"; //cubeTv
export const crusta = "#ff7926"; // onpoint
export const turquoise = "#48efa5"; //jobePipeline
export const malibu = "#52dcf5"; // charting
export const portage = "#956bf5"; // sliceandDice

//oneView
export const silverChalice = "#9e9e9e";
export const tidal = "#e1ffb0"; //matchany
export const anakiwa = "#b0ecff"; // matchblue
export const romantic = "#ffcdb0"; // matchred

// Notifications
export const ocean = "#D7E3F5";

// all colors used outside of theming rename them again contextually to app so we can change later if need

// AG Grid chart palette
export const agGridChartFills = [
  "#A06996", "#7BB9F9", "#6DC685", "#F3AE59",
  "#2254A4", "#BE96F1", "#DB4577", "#AE5B67",
  "#E4C954", "#ED702D", "#6F37B4", "#F19EAB",
  "#DE3C4C", "#36753B", "#D965A2", "#3692E7",
  "#614513", "#BECB51", "#8D6DAB", "#4397B7",
  "#A2794C", "#7CDABD", "#D2C2AF", "#5E2753",
  "#8C1A11", "#7E9843", "#FDBFA8", "#61A899",
  "#BC4024", "#47B43E", "#DFBD10", "#7838E6"
];

export const agGridChartStrokes = [
  "#684461", "#5078A2", "#478156", "#9E713A",
  "#16376B", "#7C619D", "#8E2D4D", "#713B43",
  "#948337", "#9A491D", "#482475", "#9D676F",
  "#902731", "#234C26", "#8D4269", "#235F96",
  "#3F2D0C", "#7C8435", "#5C476F", "#2C6277",
  "#694F31", "#518E7B", "#988670", "#3D1936",
  "#5B110B", "#52632C", "#A47C6D", "#3F6D63",
  "#7A2A17", "#2E7528", "#917B0A", "#4E2496"
];
